import { convertToDecimals, ILogos, IPharmacistWorkshiftList, ServiceTypes, TimeFormat } from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import { configBuilder } from '../Admin/AvailableWorkshifts/helpers';

const isSelfService = ServiceHandler.getService() === ServiceTypes.self;

export const pharmacistWorkshiftListBuilder = (
  event: Array<IPharmacistWorkshiftList>,
  allLogos: Array<ILogos>,
  timeFormat: TimeFormat,
) =>
  event.map((item) => {
    const {
      name,
      hourlyRate,
      logoId,
      startDate,
      endDate,
      city,
      workshiftId,
      pharmacyId,
      softwareName,
      replacementType,
      longTermShiftContractId,
      isAutoSyncRecord,
      contractEndDate,
      contractStartDate,
      weekDayHourlyRate,
      weekendHourlyRate,
      isInWatchlist,
    } = item;

    const avatar = allLogos.find((logo) =>
      logo.logoId === logoId)?.image;

    return {
      config: configBuilder({
        startDate,
        endDate,
        timeFormat,
        city: isSelfService ? city : '',
        software: softwareName,
      }),
      hourlyRate: convertToDecimals(hourlyRate) as number,
      title: isSelfService && !isAutoSyncRecord ? name : city,
      avatar,
      workshiftId,
      pharmacyId,
      startDate,
      endDate,
      softwareName,
      replacementType,
      longTermShiftContractId,
      isAutoSyncRecord,
      contractEndDate,
      weekDayHourlyRate,
      weekendHourlyRate,
      contractStartDate,
      isInWatchlist,
    };
  });
